// Only replace transport. Y.Doc, transaction origins and editor APIs stay native.
export function createWorkerWebSocket(createWorker, NativeSocket = globalThis.WebSocket) {
  return class WorkerSocket {
    static CONNECTING = 0; static OPEN = 1; static CLOSING = 2; static CLOSED = 3;
    OPEN = 1; readyState = 0; binaryType = 'arraybuffer';
    constructor(url, protocols) {
      this.url = url; this.protocols = protocols;
      this.started = false;
      try {
        this.worker = createWorker();
        this.worker.onmessage = ({data}) => this.receive(data);
        this.worker.onerror = () => {
          if (!this.started) this.fallback();
          else this.finish({code: 1006, reason: 'Worker failed', wasClean: false});
        };
        this.bootTimer = setTimeout(() => this.fallback(), 3000);
      } catch { this.fallback(); }
    }
    fallback() {
      // Before ready/connect only: a single-use ticket has not been consumed.
      if (this.started || this.readyState !== 0) return;
      clearTimeout(this.bootTimer); this.worker?.terminate(); this.worker = null;
      this.started = true;
      this.native = new NativeSocket(this.url, this.protocols);
      this.native.binaryType = this.binaryType;
      this.native.onopen = event => { this.readyState = 1; this.onopen?.(event); };
      this.native.onmessage = event => this.onmessage?.(event);
      this.native.onerror = event => this.onerror?.(event);
      this.native.onclose = event => this.finish(event);
    }
    receive(data) {
      if (data.type === 'ready' && this.readyState === 0 && !this.started) {
        clearTimeout(this.bootTimer); this.started = true;
        this.worker.postMessage({type: 'connect', url: this.url, protocols: this.protocols});
      } else if (data.type === 'open' && this.readyState === 0) {
        this.readyState = 1; this.onopen?.({type: 'open'});
      } else if (data.type === 'message' && this.readyState === 1) this.onmessage?.({data: data.data});
      else if (data.type === 'error') this.onerror?.({type: 'error'});
      else if (data.type === 'close') this.finish(data);
    }
    finish(event) {
      if (this.readyState === 3) return;
      clearTimeout(this.bootTimer); this.worker?.terminate();
      this.readyState = 3; this.onclose?.(event);
    }
    send(data) {
      if (this.readyState !== 1) throw new Error('WebSocket is not open');
      if (this.native) this.native.send(data);
      else this.worker.postMessage({type: 'send', data});
    }
    close(code, reason) {
      if (this.readyState >= 2) return;
      this.readyState = 2; clearTimeout(this.bootTimer);
      if (this.native) this.native.close(code, reason);
      else if (this.started) this.worker.postMessage({type: 'close', code, reason});
      else this.finish({code: 1000, reason: '', wasClean: true});
    }
  };
}
